import {ChangeDetectionStrategy, Component, input, signal} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TenderPhaseType} from '@frontend/shared-api';
import {
  ProviderResultsDisplayMode,
  ProviderResultsTableComponent,
} from '../../../../../../../../shared/components/table/provider-results-table/provider-results-table.component';

interface DetailedAnalysisPhaseSection {
  phase: TenderPhaseType;
  titleKey: string;
}

@Component({
  selector: 'app-detailed-analysis',
  imports: [TranslocoPipe, ProviderResultsTableComponent],
  templateUrl: './detailed-analysis.component.html',
  styleUrl: './detailed-analysis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailedAnalysisComponent {
  readonly projectId = input<number | undefined>(undefined);
  readonly includedHrToolDirectusIds = input<string[] | undefined>(undefined);

  protected readonly TenderPhaseType = TenderPhaseType;
  protected readonly phaseSections: DetailedAnalysisPhaseSection[] = [
    {
      phase: TenderPhaseType.RFI,
      titleKey: 'project.steps.rfi.providerResult.title',
    },
    {
      phase: TenderPhaseType.RFP,
      titleKey: 'project.steps.rfp.providerResult.title',
    },
    {
      phase: TenderPhaseType.RFD,
      titleKey: 'project.steps.rfd.providerResult.title',
    },
    {
      phase: TenderPhaseType.RFQ,
      titleKey: 'project.steps.rfq.providerResult.title',
    },
  ];

  private readonly displayModesByPhase = signal(
    new Map<TenderPhaseType, ProviderResultsDisplayMode>(
      this.phaseSections.map((section) => [section.phase, 'table']),
    ),
  );

  protected getDisplayMode(phase: TenderPhaseType): ProviderResultsDisplayMode {
    return this.displayModesByPhase().get(phase) ?? 'table';
  }

  protected setDisplayMode(phase: TenderPhaseType, mode: ProviderResultsDisplayMode): void {
    const next = new Map(this.displayModesByPhase());
    next.set(phase, mode);
    this.displayModesByPhase.set(next);
  }
}
